import { useSelector } from 'react-redux'
import './styles/_default.scss'

const RestrictedOverlay = () => {
  const { languageData } = useSelector((state) => state.language)

  return (
    <div className='restricted-overlay'>
      <div className='restricted-text'>
        <i className='fa-solid fa-cloud-slash fa-xl d-block mb-4' />
        {languageData?.notAvailableInRegion || 'Not available in your region'}
      </div>
    </div>
  )
}

export default RestrictedOverlay
